const messages = {
    et: require('./et.json'),
    ru: require('./ru.json'),
};

export default messages;